export const SKU_LIST_G64000: string[] = [
    "G64000-Bl-S",
    "G64000-Bl-M",
    "G64000-Bl-L",
    "G64000-Bl-XL",
    "G64000-Bl-2XL",
    "G64000-Bl-3XL",
    "G64000-Bl-4XL",
    "G64000-Bl-5XL",
    "G64000-MilGr-S",
    "G64000-MilGr-M",
    "G64000-MilGr-L",
    "G64000-MilGr-XL",
    "G64000-MilGr-2XL",
    "G64000-MilGr-3XL",
    "G64000-MilGr-4XL",
   // "G64000-MilGr-5XL",
    "G64000-Or-S",
    "G64000-Or-M",
    "G64000-Or-L",
    "G64000-Or-XL",
    "G64000-Or-2XL",
    "G64000-Or-3XL",
    "G64000-Or-4XL",
 //   "G64000-Or-5XL",
    "G64000-DaHe-S",
    "G64000-DaHe-M",
    "G64000-DaHe-L",
    "G64000-DaHe-XL",
    "G64000-DaHe-2XL",
    "G64000-DaHe-3XL",
    "G64000-DaHe-4XL",
    "G64000-DaHe-5XL",
    "G64000-San-S",
    "G64000-San-M",
    "G64000-San-L",
    "G64000-San-XL",
    "G64000-San-2XL",
    "G64000-San-3XL",
 //   "G64000-San-4XL",
 //   "G64000-San-5XL",
    "G64000-LiBl-S",
    "G64000-LiBl-M",
    "G64000-LiBl-L",
    "G64000-LiBl-XL",
    "G64000-LiBl-2XL",
    "G64000-LiBl-3XL",
    "G64000-LiBl-4XL",
   // "G64000-LiBl-5XL",
    "G64000-Ma-S",
    "G64000-Ma-M",
    "G64000-Ma-L",
    "G64000-Ma-XL",
    "G64000-Ma-2XL",
    "G64000-Ma-3XL",
    "G64000-Ma-4XL",
 //   "G64000-Ma-5XL",
    "G64000-IrGr-S",
    "G64000-IrGr-M",
    "G64000-IrGr-L",
    "G64000-IrGr-XL",
    "G64000-IrGr-2XL",
    "G64000-IrGr-3XL",
    "G64000-IrGr-4XL",
  //  "G64000-IrGr-5XL",
    "G64000-Pu-S",
    "G64000-Pu-M",
    "G64000-Pu-L",
    "G64000-Pu-XL",
    "G64000-Pu-2XL",
    "G64000-Pu-3XL",
    "G64000-Pu-4XL",
//    "G64000-Pu-5XL",
    "G64000-Cha-S",
    "G64000-Cha-M",
    "G64000-Cha-L",
    "G64000-Cha-XL",
    "G64000-Cha-2XL",
    "G64000-Cha-3XL",
    "G64000-Cha-4XL",
    "G64000-Cha-5XL",
    "G64000-Wh-S",
    "G64000-Wh-M",
    "G64000-Wh-L",
    "G64000-Wh-XL",
    "G64000-Wh-2XL",
    "G64000-Wh-3XL",
    "G64000-Wh-4XL",
    "G64000-Wh-5XL",
    "G64000-Na-S",
    "G64000-Na-M",
    "G64000-Na-L",
    "G64000-Na-XL",
    "G64000-Na-2XL",
    "G64000-Na-3XL",
    "G64000-Na-4XL",
    "G64000-Na-5XL",
    "G64000-DaCho-S",
    "G64000-DaCho-M",
    "G64000-DaCho-L",
    "G64000-DaCho-XL",
    "G64000-DaCho-2XL",
    "G64000-DaCho-3XL",
  //  "G64000-DaCho-4XL",
  //  "G64000-DaCho-5XL",
    "G64000-Re-S",
    "G64000-Re-M",
    "G64000-Re-L",
    "G64000-Re-XL",
    "G64000-Re-2XL",
    "G64000-Re-3XL",
    "G64000-Re-4XL",
    "G64000-Re-5XL",
    "G64000-Ro-S",
    "G64000-Ro-M",
    "G64000-Ro-L",
    "G64000-Ro-XL",
    "G64000-Ro-2XL",
    "G64000-Ro-3XL",
    "G64000-Ro-4XL",
    "G64000-Ro-5XL",
    "G64000-SpGr-S",
    "G64000-SpGr-M",
    "G64000-SpGr-L",
    "G64000-SpGr-XL",
    "G64000-SpGr-2XL",
    "G64000-SpGr-3XL",
    "G64000-SpGr-4XL",
    "G64000-SpGr-5XL",
    "G64000-LiPi-S",
    "G64000-LiPi-M",
    "G64000-LiPi-L",
    "G64000-LiPi-XL",
    "G64000-LiPi-2XL",
    "G64000-LiPi-3XL",
  //  "G64000-LiPi-4XL",
  //  "G64000-LiPi-5XL",
    "G64000-AnSa-S",
    "G64000-AnSa-M",
    "G64000-AnSa-L",
    "G64000-AnSa-XL",
    "G64000-AnSa-2XL",
    "G64000-AnSa-3XL",
 //   "G64000-AnSa-4XL",
 //   "G64000-AnSa-5XL",
    "G64000-Az-S",
    "G64000-Az-M",
    "G64000-Az-L",
    "G64000-Az-XL",
    "G64000-Az-2XL",
    "G64000-Az-3XL",
 //   "G64000-Az-4XL",
 //   "G64000-Az-5XL",
    "G64000-CaRe-S",
    "G64000-CaRe-M",
    "G64000-CaRe-L",
    "G64000-CaRe-XL",
    "G64000-CaRe-2XL",
    "G64000-CaRe-3XL",
    "G64000-CaRe-4XL",
  //  "G64000-CaRe-5XL",
    "G64000-CaBl-S",
    "G64000-CaBl-M",
    "G64000-CaBl-L",
    "G64000-CaBl-XL",
    "G64000-CaBl-2XL",
    "G64000-CaBl-3XL",
 //   "G64000-CaBl-4XL",
 //   "G64000-CaBl-5XL",
    "G64000-FoGr-S",
    "G64000-FoGr-M",
    "G64000-FoGr-L",
    "G64000-FoGr-XL",
    "G64000-FoGr-2XL",
    "G64000-FoGr-3XL",
 //   "G64000-FoGr-4XL",
 //   "G64000-FoGr-5XL",
    "G64000-Nat-S",
    "G64000-Nat-M",
    "G64000-Nat-L",
    "G64000-Nat-XL",
    "G64000-Nat-2XL",
    "G64000-Nat-3XL",
 //   "G64000-Nat-4XL",
 //   "G64000-Nat-5XL",
    "G64000-Da-S",
    "G64000-Da-M",
    "G64000-Da-L",
    "G64000-Da-XL",
    "G64000-Da-2XL",
    "G64000-Da-3XL",
    "G64000-Da-4XL",
 //   "G64000-Da-5XL",
    "G64000-AnChRe-S",
    "G64000-AnChRe-M",
    "G64000-AnChRe-L",
    "G64000-AnChRe-XL",
    "G64000-AnChRe-2XL",
    "G64000-AnChRe-3XL",
 //   "G64000-AnChRe-4XL",
 //   "G64000-AnChRe-5XL",
    "G64000-MiGr-S",
    "G64000-MiGr-M",
    "G64000-MiGr-L",
    "G64000-MiGr-XL",
    "G64000-MiGr-2XL",
    "G64000-MiGr-3XL",
//    "G64000-MiGr-4XL",
//    "G64000-MiGr-5XL",
    "G64000-InBl-S",
    "G64000-InBl-M",
    "G64000-InBl-L",
    "G64000-InBl-XL",
    "G64000-InBl-2XL",
    "G64000-InBl-3XL",
    "G64000-InBl-4XL",
//    "G64000-InBl-5XL",
    "G64000-GrHe-S",
    "G64000-GrHe-M",
    "G64000-GrHe-L",
    "G64000-GrHe-XL",
    "G64000-GrHe-2XL",
    "G64000-GrHe-3XL",
    "G64000-GrHe-4XL",
  //  "G64000-GrHe-5XL",
    "G64000-Li-S",
    "G64000-Li-M",
    "G64000-Li-L",
    "G64000-Li-XL",
    "G64000-Li-2XL",
    "G64000-Li-3XL",
 //   "G64000-Li-4XL",
 //   "G64000-Li-5XL",
    "G64000-Sap-S",
    "G64000-Sap-M",
    "G64000-Sap-L",
    "G64000-Sap-XL",
    "G64000-Sap-2XL",
    "G64000-Sap-3XL",
    "G64000-Sap-4XL",
 //   "G64000-Sap-5XL",
    "G64000-Ki-S",
    "G64000-Ki-M",
    "G64000-Ki-L",
    "G64000-Ki-XL",
    "G64000-Ki-2XL",
    "G64000-Ki-3XL",
//    "G64000-Ki-4XL",
//    "G64000-Ki-5XL",
    "G64000-Sky-S",
    "G64000-Sky-M",
    "G64000-Sky-L",
    "G64000-Sky-XL",
    "G64000-Sky-2XL",
    "G64000-Sky-3XL",
//    "G64000-Sky-4XL",
//    "G64000-Sky-5XL",
    "G64000-Hel-S",
    "G64000-Hel-M",
    "G64000-Hel-L",
    "G64000-Hel-XL",
    "G64000-Hel-2XL",
    "G64000-Hel-3XL",
 //   "G64000-Hel-4XL",
 //   "G64000-Hel-5XL",
    "G64000-StBl-S",
    "G64000-StBl-M",
    "G64000-StBl-L",
    "G64000-StBl-XL",
    "G64000-StBl-2XL",
    "G64000-StBl-3XL",
 //   "G64000-StBl-4XL",
 //   "G64000-StBl-5XL",
    "G64000-HeNa-S",
    "G64000-HeNa-M",
    "G64000-HeNa-L",
    "G64000-HeNa-XL",
    "G64000-HeNa-2XL",
    "G64000-HeNa-3XL",
    "G64000-HeNa-4XL",
    "G64000-HeNa-5XL",
    "G64000-HeRo-S",
    "G64000-HeRo-M",
    "G64000-HeRo-L",
    "G64000-HeRo-XL",
    "G64000-HeRo-2XL",
    "G64000-HeRo-3XL",
    "G64000-HeRo-4XL",
    "G64000-HeRo-5XL",
    "G64000-ChRe-S",
    "G64000-ChRe-M",
    "G64000-ChRe-L",
    "G64000-ChRe-XL",
    "G64000-ChRe-2XL",
    "G64000-ChRe-3XL",
//    "G64000-ChRe-4XL",
//    "G64000-ChRe-5XL",
    "G64000-Pis-S",
    "G64000-Pis-M",
    "G64000-Pis-L",
    "G64000-Pis-XL",
    "G64000-Pis-2XL",
    "G64000-Pis-3XL",
//    "G64000-Pis-4XL",
//    "G64000-Pis-5XL",
    "G64000-Par-S",
    "G64000-Par-M",
    "G64000-Par-L",
    "G64000-Par-XL",
    "G64000-Par-2XL",
    "G64000-Par-3XL",
 //   "G64000-Par-4XL",
 //   "G64000-Par-5XL",
    "G64000-HeMiGr-S",
    "G64000-HeMiGr-M",
    "G64000-HeMiGr-L",
    "G64000-HeMiGr-XL",
    "G64000-HeMiGr-2XL",
    "G64000-HeMiGr-3XL",
    "G64000-HeMiGr-4XL",
 //   "G64000-HeMiGr-5XL",
    "G64000-JaDo-S",
    "G64000-JaDo-M",
    "G64000-JaDo-L",
    "G64000-JaDo-XL",
    "G64000-JaDo-2XL",
    "G64000-JaDo-3XL",
 //   "G64000-JaDo-4XL",
 //   "G64000-JaDo-5XL",
    "G64000-TroBl-S",
    "G64000-TroBl-M",
    "G64000-TroBl-L",
    "G64000-TroBl-XL",
    "G64000-TroBl-2XL",
    "G64000-TroBl-3XL",
  //  "G64000-TroBl-4XL",
  //  "G64000-TroBl-5XL",
    "G64000-OffWh-S",
    "G64000-OffWh-M",
    "G64000-OffWh-L",
    "G64000-OffWh-XL",
    "G64000-OffWh-2XL",
    "G64000-OffWh-3XL",
    "G64000-OffWh-4XL",
    "G64000-OffWh-5XL"
]